import React from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import MyReportIcon from "../../atoms/icons/my-report";
import MyReportHindiIcon from "../../atoms/icons/my-report-hindi";
// import FitConnect from "../../atoms/icons/fit-connect";
import Button from "../../atoms/button";

import translate from "../../translate";

import "./myReport.m.css";

const MyReport = ({ publisherName }) => {
  const getIcon = () => {
    if (publisherName === "quint-hindi") {
      return <MyReportHindiIcon />;
    }

    // if (publisherName === "fit") {
    //   return <FitConnect />;
    // }

    return <MyReportIcon />;
  };

  // AQI widget added fot FIT only
  if (publisherName === "fit") {
    return (
      <iframe
        styleName="aqi-widget"
        src="https://fit.thequint.com/quintlab/widgets/air-quality-index/embed/"
        alt="AQI widget"
      />
    );
  }
  return (
    <a
      href={publisherName === "fit" ? "/fit-connect" : "/your-story"}
      styleName="wrapper"
      target="_blank"
      rel="nofollow"
    >
      {getIcon()}
      <span styleName="send-us-your-videosarticles">{translate(publisherName, "send_ur_your_articles")}</span>
      <Button content={translate(publisherName, "click_here")} />
    </a>
  );
};

MyReport.propTypes = {
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(MyReport);
